import logo2 from "../assets/logo2.png";
import "./Navbar.css";

function Navbar({ onCambiarVista }) {
  const rol = localStorage.getItem("rol"); // SUPERADMIN | ADMIN | AFILIADO | null

  const cerrarSesion = () => {
    localStorage.removeItem("rol");
    localStorage.removeItem("user");
    onCambiarVista("login");  
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top navbar-custom">
      <div className="container-fluid">
        {/* LOGO */}
        <img
          src={logo2}
          alt="SINTRASECSALUD"
          className="navbar-logo"
          onClick={() => onCambiarVista("inicio")}
          style={{ cursor: "pointer" }}
        />

        {/* BOTÓN RESPONSIVE */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#menuNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENÚ */}
        <div className="collapse navbar-collapse" id="menuNavbar">
          <ul className="navbar-nav ms-auto align-items-center">
            {/* ===== PÚBLICOS ===== */}
            <li className="nav-item">
              <span
                className="nav-link-custom"
                onClick={() => onCambiarVista("inicio")}
              >
                Inicio
              </span>
            </li>

            <li className="nav-item">
              <span
                className="nav-link-custom"
                onClick={() => onCambiarVista("quienes")}
              >
                Quiénes Somos
              </span>
            </li>

            <li className="nav-item">
              <span
                className="nav-link-custom"
                onClick={() => onCambiarVista("estatutos")}
              >
                Estatutos
              </span>
            </li>

            <li className="nav-item">
              <span
                className="nav-link-custom"
                onClick={() => onCambiarVista("contacto")}
              >
                Contáctenos
              </span>
            </li>

            {/* ===== ADMIN / SUPERADMIN ===== */}
            {(rol === "ADMIN" || rol === "SUPERADMIN") && (
              <li className="nav-item ms-2">
                <button
                  className="btn btn-warning"
                  onClick={() => onCambiarVista("adminAprobar")}
                >
                  Aprobar Afiliados
                </button>
              </li>
            )}

            {/* ===== NO LOGUEADO ===== */}
            {!rol && (
              <>
                <li className="nav-item ms-3">
                  <button
                    className="nav-auth-btn"
                    onClick={() => onCambiarVista("login")}
                  >
                    Iniciar sesión
                  </button>
                </li>

                <li className="nav-item ms-2">
                  <button
                    className="nav-auth-btn"
                    onClick={() => onCambiarVista("formulario")}
                  >
                    Registrarse
                  </button>
                </li>
              </>
            )}

            {/* ===== LOGUEADO ===== */}
            {rol && (
              <li className="nav-item ms-3">
                <button
                  className="btn btn-outline-light"
                  onClick={cerrarSesion}
                >
                  Cerrar sesión
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;